export default {
  nav: {
    reserve: 'Reservar Ahora',
    cart: 'Carrito',
    menu: 'Menú',
    language: 'Idioma',
    about: "Sobre Nosotros",
    contact: "Contacto",
    categories: "Categorías de paseos",
  },
  hero: {
    line1: 'Barcos, senderos y aventuras en',
    line2: 'Paraty',
    subtitle: 'Paseos en barco, lanchas privadas, jeep tour y buceo.',
    subtitleHighlight: 'Experiencias únicas',
    ctaTours: 'Ver Paseos',
    ctaContact: 'Contactar',
    scroll: 'Explorar',
    statYears: 'Años de Experiencia',
    statGuests: 'Pasajeros Felices',
    statBeaches: 'Playas e Islas',
  },
  tours: {
    label: 'Nuestros Paseos',
    title: 'Descubre lo mejor de Paraty',
    subtitle: 'Paseos cuidadosamente seleccionados para que disfrutes cada momento.',
    duration: 'Duración',
    difficulty: 'Dificultad',
    from: 'Desde',
    details: 'Ver Detalles',
    seeAll: 'Ver todos los paseos',
    limited: 'Cupos Limitados',
    fewLeft: 'Pocos cupos',
    flashDeal: 'Oferta Relámpago',
    offerEnds: 'Oferta termina en:',
    offerPrice: 'Precio Oferta',
    stillOffer: '¡Aún en oferta!',
    categories: {
      all: 'Todos',
      escunas: 'Barcos',
      jeep: 'Paseos en Jeep',
      compartilhadas: 'Lanchas Compartidas',
      privadas: 'Lanchas y Barcos Privados',
      bolivia: 'Expedición Bolivia 🇧🇴',
    },
  },
  why: {
    label: '¿Por qué elegir AQUAMARINA?',
    title: 'Una experiencia que va más allá del paseo',
    pillars: {
      safety: 'Seguridad en primer lugar',
      guides: 'Guías locales experimentados',
      boats: 'Embarcaciones de calidad',
      price: 'Precio justo y transparente',
    },
  },
  testimonials: {
    label: 'Testimonios',
    title: 'Lo que dicen nuestros pasajeros',
    subtitle: 'Experiencias reales de quienes ya navegaron con nosotros.',
  },
  faq: {
    label: 'Preguntas Frecuentes',
    title: 'Preguntas & Respuestas',
    subtitle: 'Todo lo que necesitas saber antes de embarcar.',
  },
  contact: {
    label: 'Reserva tu aventura',
    title: 'Contacto & Reservas',
    subtitle: '¿Listo para sumergirte en una experiencia inolvidable?',
    form: {
      name: 'Nombre completo',
      email: 'Correo electrónico',
      phone: 'WhatsApp',
      date: 'Fecha del paseo',
      message: 'Cuéntanos sobre tu aventura ideal',
      submit: 'Enviar mensaje',
      sending: 'Enviando...',
      successTitle: '¡Mensaje enviado!',
      successText: 'Nuestro equipo se pondrá en contacto pronto.',
    },
    location: 'Dónde estamos',
    attendance: 'Atención',
    schedule1: 'Lunes a Sábado: 08h a 20h',
    schedule2: 'Domingo: 09h a 17h',
    email: 'paraty.sirenatours@gmail.com',
    whatsappLabel: 'Atención rápida',
    address: 'Av. Roberto Silveira 578, Centro — Paraty, RJ',
    mapLink: 'Ver en Google Maps',
  },
  bolivia: {
    badge: 'Oferta de Apertura',
    title: 'Descubre Bolivia con Nosotros',
    subtitle: 'Explora el mayor desierto de sal del mundo, lagunas coloridas, volcanes y paisajes de otro mundo en el Altiplano Boliviano.',
    cta: 'Conoce la Expedición',
    seeAll: 'Ver todos los paseos',
    highlights: ['3 Días / 2 Noches', 'Grupo Reducido', 'Guía Experto', 'Todo Incluido'],
    openingOffer: 'Precio de Apertura',
    promoBadge: 'Precio Promocional',
    promoPrice: 'Precio Promocional',
    price: 'R$ 1.200',
    originalPrice: 'R$ 1.500',
    perPerson: 'por persona',
    allIncluded: 'Todo Incluido',
    includedTitle: 'Qué está incluido',
    accommodation: 'Alojamiento 2 noches',
    meals: 'Todas las comidas',
    transport: 'Transporte 4x4',
    guide: 'Guía experto',
    sunset: 'Atardecer en el Salar',
    flamingos: 'Flamencos & Lagunas',
    newActivity: 'NUEVA ACTIVIDAD',
    newActivityDesc: 'Degustación de vinos bolivianos de altura al atardecer',
  },
  footer: {
    rights: 'Todos los derechos reservados.',
    company: 'AQUAMARINA TOURS',
    tagline: 'Experiencias oceánicas únicas en Paraty',
    links: {
      home: 'Inicio',
      tours: 'Paseos',
      contact: 'Contacto',
      terms: 'Términos y Condiciones',
      privacy: 'Política de Privacidad',
    },
  },
  category: {
    back: 'Inicio',
    emptyTitle: 'No se encontraron paseos',
    emptyText: 'No hay paseos disponibles en esta categoría por el momento.',
    ctaAll: 'Ver todos los paseos',
  },
  booking: {
    reserve: 'Reserva tu paseo',
    date: 'Fecha del paseo',
    adults: 'Adultos (10+ años) — Precio completo',
    children: 'Niños (5 a 9 años) — Mitad de precio',
    babies: 'Bebés (0 a 4 años) — Cortesía',
    adultPrice: 'cada uno',
    childPrice: 'cada uno',
    babyPrice: 'Gratis',
    total: 'Total estimado',
    addCart: 'Añadir al carrito',
    added: '¡Añadido!',
    cartSuccess: '¡Paseo añadido al carrito!',
    reserveNow: 'Reservar ahora',
    pixTitle: '¿Cómo funciona la reserva?',
    pixText1: 'Para completar la reserva, necesitas pagar una seña vía PIX.',
    pixText2: 'El resto del pago se realiza el día del paseo, directamente en el lugar de embarque.',
    pixText3: 'Después del pago de la seña, enviaremos el voucher con toda la información.',
    whatsappCta: 'Continuar reserva por WhatsApp',
    back: 'Volver',
    selectDateAlert: 'Por favor, selecciona una fecha para el paseo.',
    whatsappModal: {
      title: 'Confirmar Reserva',
      totalTours: 'Total de paseos',
      totalPeople: 'Total de personas',
      grandTotal: 'Valor total estimado',
      priceReference: 'Precios de Referencia',
      perPerson: 'Por persona',
      startingFrom: 'A partir de',
      warningTitle: '⚠️ ¡Atención! Lee antes de continuar',
      warning1: 'Serás redirigido a WhatsApp con todos los detalles de los paseos, cantidad de personas, fechas y precios.',
      warning2: 'El valor de la seña vía PIX será informado por nuestro equipo en WhatsApp según los paseos seleccionados.',
      warning3: 'El pago restante se realiza el día del paseo, directamente en el lugar de embarque.',
      warning4: 'Después del pago de la seña, enviaremos el voucher con toda la información de tu reserva.',
      acceptTerms: 'He leído y acepto. Entiendo que seré redirigido a WhatsApp para finalizar la reserva.',
      acceptAndGo: 'Aceptar e ir a WhatsApp',
      cancel: 'Cancelar',
      fullName: 'Tu nombre completo',
      fullNamePlaceholder: 'Ej: Juan Pérez',
      nameRequired: 'Por favor, escribe tu nombre completo para continuar.',
    },
  },
  cart: {
    title: 'Tu Carrito',
    empty: 'Tu carrito está vacío',
    emptyCta: 'Explorar paseos',
    itemAdults: 'Adultos',
    itemChildren: 'Niños',
    itemBabies: 'Bebés',
    remove: 'Eliminar',
    total: 'Total estimado',
    continue: 'Continuar reservando',
    reserveAll: 'Reservar todo por WhatsApp',
  },
  notFound: {
    title: 'Página no encontrada',
    back: 'Volver al inicio',
  },
  tour: {
    about: 'Sobre este paseo',
    itinerary: 'Itinerario del día',
    included: 'Lo que está incluido',
    notIncluded: 'No está incluido',
    bring: 'Qué llevar',
    info: 'Información práctica',
    policy: 'Política, Términos y Avisos Importantes',
    importantNotes: 'Avisos importantes',
    cancellation: 'Política de cancelación',
    cancellationPolicy: "Con 7 días o más de anticipación: reembolso del 100%. Entre 7 días y 48 horas antes del paseo: retención del 20% (reembolso del 80%). Con menos de 48 horas o no presentación (no-show): sin reembolso. Si la empresa cancela por seguridad o mal tiempo: reembolso del 100%.",
    terms: 'Términos y condiciones',
    meetingPoint: 'Punto de encuentro',
    startTime: 'Hora de inicio',
    duration: 'Duración',
    difficulty: 'Dificultad',
    groupSize: 'Tamaño del grupo',
    related: 'Paseos que también te pueden gustar',
    reviews: 'Reseñas Reales',
    reviewsSubtitle: 'Testimonios de quienes ya vivieron esta experiencia con AQUAMARINA.',
    back: 'Volver',
    tab: {
      descricao: 'Descripción',
      roteiro: 'Itinerario',
      incluso: 'Lo que está incluido',
      levar: 'Qué llevar',
      info: 'Información',
      politica: 'Política',
    },
    gallery: {
      prev: 'Imagen anterior',
      next: 'Siguiente imagen',
      viewPhoto: 'Ver foto',
    },
  },
};
